import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MenuItem } from '../../definition';

import { mmMenuConstants } from '../../menu-constants';
import { BehaviorSubject, merge, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { MmMenuApiService } from 'mm-web-core/menu/services/menu-api.service';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { NzIconService } from "ng-zorro-antd/icon";
import { MmValidators } from 'mm-web-core/form/validators';
import { MmTranslateService } from 'mm-web-core/i18n';
import { onFormSubmit } from 'shared/utils';

@Component({
  templateUrl: './menu-form.component.html',
  styleUrls: ['./menu-form.component.scss']
})
export class MenuFormComponent implements OnInit {

  form: FormGroup;
  model$ = new BehaviorSubject<MenuItem>(<MenuItem>{});
  items: MenuItem[];
  parent: MenuItem;
  showUrlInput$: Observable<boolean>;
  showMenuApiUrlInput$: Observable<boolean>;
  showHttpUrlInput$: Observable<boolean>;
  selectedOS = null;
  icons: Array<any> = [];
  systemMenu: any[] = [];
  @Input() showFolderOption: boolean =true;
  constructor(private fb: FormBuilder, private api: MmMenuApiService, private modalRef: NzModalRef,
    private mmTranslateService: MmTranslateService,
    private iconService: NzIconService) {
    this.form = fb.group({
      'name': fb.control(undefined, [MmValidators.required(),Validators.maxLength(20)]),
      "moduleUrl": fb.control(undefined,[]),
      "httpUrl": fb.control(undefined,[]),
      "type": fb.control("Link",[]),
      "icon": fb.control(undefined),
      "description": fb.control(undefined),
      "permission": fb.control(undefined),
    });
    this.icons = ['union', 'electricityData', 'area', 'analyse', 'set', 'overview'];
  }

  set model(_: MenuItem) {
    this.model$.next(_);
  }

  size = {
    label: "100px",
    control: "auto"
  }

  ngOnInit(): void {
    this.api.getSystemMenu().subscribe(res => {
      this.systemMenu = res;
      this.setExistedUrlDisabled();
    });
    this.model$.subscribe(m => {
      // 新增菜单给默认菜单类型“内部链接”加验证
      if(Object.keys(m).length === 0){
        this.form.get('moduleUrl').setValidators(Validators.required);
      };
      const values = {
        ...{
          type: "Link",
        },
        ...m,
        name:m.name?.zh
      }
      //根据菜单类型给url赋值
      if(values.type === "ExternalLink"){
        this.form.get('httpUrl').patchValue(values.url);
      }else if(values.type === "Link"){
        this.form.get('moduleUrl').patchValue(values.url);
      }
      this.form.patchValue(values, { emitEvent: true })
    });
    this.showUrlInput$ = merge(
      of(this.form.controls['type'].value),
      this.form.controls['type'].valueChanges
    ).pipe(map(t => t == "Link"));

    this.showMenuApiUrlInput$ = merge(
      of(this.form.controls['type'].value),
      this.form.controls['type'].valueChanges
    ).pipe(map(t => t == "Dynamic"));

    this.showHttpUrlInput$ = merge(
      of(this.form.controls['type'].value),
      this.form.controls['type'].valueChanges
    ).pipe(map(t => t == "RedirectLink" || t == "ExternalLink"));
    this.bindValueChanges();
  }
  private bindValueChanges() {
    this.form.controls['type'].valueChanges.subscribe(value => {
        if (value === 'Link') {
            this.form.get('moduleUrl').setValidators(Validators.required);
            this.form.get('httpUrl').setValidators(null);
        } else if(value === 'ExternalLink'){
          this.form.get('httpUrl').setValidators(Validators.required);
          this.form.get('moduleUrl').setValidators(null);
        }else if(value === 'Folder'){
          this.form.get('moduleUrl').setValidators(null);
          this.form.get('httpUrl').setValidators(null);
        }
    });
}
  urlChanged(url) {
    var item = this.systemMenu.filter(item => item.url === url)[0];
    this.form.patchValue({ permission: item.permission }, { emitEvent: true })
  };
  
  // if the url has been configured, set disabled = true that can not be selected
  setExistedUrlDisabled() {
    //get all existed url from the current menu table
    var existedUrls = [];
    this.items.forEach(item => {
      existedUrls.push(item.url);
      if (item.items) {
        item.items.forEach(childItem => {
          existedUrls.push(childItem.url);
        });
      }
    }
    );
    // find all url in system menu that existed in existedUrls and set disabled = true
    this.systemMenu.forEach(item => {
      if (existedUrls.includes(item.url)) {
        item.disabled = true;
      }
    });
  }
  async save() {
    onFormSubmit(this.form);
    //根据菜单类型给后端所需的url赋值
    let url=null;
    if(this.form.get('type').value == 'Link'){
      url = this.form.get('moduleUrl').value;
    }else if(this.form.get('type').value == 'ExternalLink'){
      url = this.form.get('httpUrl').value;
    }
    if (this.form.invalid) { return; }
    const payload = {
      ...this.model$.value,
      ...this.form.value,
      name:{
        zh:this.form.get('name').value,
        en:this.form.get('name').value
      },
      url: url
    } as MenuItem;
    
    if (payload.id) {
      const item = findItem(this.items, payload.id);
      Object.assign(item, payload);
    }
    else if (this.parent) {
      if (!this.parent.items) {
        this.parent.items = [];
      }
      this.parent.items.push(payload);
    }
    else {
      this.items.push(payload);
    }
    await this.api.saveMenuTree(this.items).toPromise();
    this.modalRef.close(true);
  }


  cancel() {
    this.modalRef.close();

  }

  resolveKey(key: string) {
    return `${mmMenuConstants.translationGroup}.${key}`;
  }

}

function findItem(items: MenuItem[], id: string) {
  for (const item of items) {
    if (item.id == id) return item;
    if (item.items && item.items.length > 0) {
      const childItem = findItem(item.items, id);
      if (childItem) return childItem;
    }
  }
}
